import { defineMessages } from "../core"

export const preview = defineMessages({
  en: {
    "preview.download": "Download file",
    "preview.openInNewTab": "Open in new tab",
    "preview.close": "Close preview",
    "preview.tabPreview": "Preview",
    "preview.tabSummary": "AI Summary",
    "preview.cannotPreview": "This document cannot be previewed here.",
    "preview.loading": "Loading preview…",
    "preview.prevPage": "Previous page",
    "preview.nextPage": "Next page",
    "preview.pageOf": "Page {page} of {total}",
    "preview.summaryFailed": "Could not load summary.",
    "preview.summaryGenerating": "Generating summary…",
  },
  de: {
    "preview.download": "Datei herunterladen",
    "preview.openInNewTab": "In neuem Tab öffnen",
    "preview.close": "Vorschau schließen",
    "preview.tabPreview": "Vorschau",
    "preview.tabSummary": "KI-Zusammenfassung",
    "preview.cannotPreview": "Dieses Dokument kann hier nicht angezeigt werden.",
    "preview.loading": "Vorschau wird geladen…",
    "preview.prevPage": "Vorherige Seite",
    "preview.nextPage": "Nächste Seite",
    "preview.pageOf": "Seite {page} von {total}",
    "preview.summaryFailed": "Die Zusammenfassung konnte nicht geladen werden.",
    "preview.summaryGenerating": "Zusammenfassung wird erstellt…",
  },
})
